import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReviewPopupKYC from './review-popup';
import DocumentPreview from '../Create-Investment/documentpreview';
import ActivityLog from '../../Components/ActivityLog/activity-log';
import StatusButton from '../../Components/Onbaording/status-button';
import SectionStatusGrid from '../../Components/Onbaording/status-section';
import FileUploadDisplay from '../../Components/Onbaording/file-display';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';
import UserQuestionnaire from '../Risk-Assessment/user-questionnarie';
import EDDModal from '../Risk-Assessment/edd-modal';
import AuditStepper from '../../Components/Onbaording/onboarding-stepper';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

// const steps = [
//   {
//     key: 'submitted',
//     label: 'Application Submitted',
//     icon: 'description',
//     status: 'completed',
//   },
//   // {
//   //   key: 'sanction',
//   //   label: 'Sanction Verified',
//   //   icon: 'gavel',
//   //   status: 'completed',
//   // },
//   {
//     key: 'identity',
//     label: 'Identity Verified',
//     icon: 'verified_user',
//     status: 'completed',
//   },
//   {
//     key: 'manual',
//     label: 'Manual Review',
//     icon: 'manage_search',
//     status: 'active',
//   },
//   {
//     key: 'approved',
//     label: 'Approved',
//     icon: 'check_circle',
//     status: 'pending',
//   },
// ];
const ReviewKycJointAccountReadOnly = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const buttonRefs = useRef({});
  const { customerId } = useParams();
  const navigate = useNavigate();
  const [eddResponse, setEddResponse] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const roleName = useSelector((state) => state.user.roleName);
  const updateFieldStatus = useSelector(
    (state) => state.form.updateFieldStatus,
  );
  const [meetingData, setMeetingData] = useState([]);
  const [steps, setSteps] = useState([]);

  const [sanctionResults, setSanctionResults] = useState(null);
  const [livenessConfirmed, setLivenessConfirmed] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState('');
  const [dvsTime, setDvsTime] = useState('');
  const [dvsMeessage, setDvsMeessage] = useState('');
  const location = useLocation();
  const { showToast } = useToast();
  const [showPopup, setShowPopup] = useState(false);
  const [photoIdSecondText, setphotoIdSecondText] = useState(null);
  const [photoIdSecond, setphotoIdSecond] = useState(null);
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [fullName, setFullName] = useState(null);
  const [nonphotoIdText, setNonPhotoIdText] = useState('');
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [expiryDateSecond, setExpiryDateSecond] = useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [documentNumber, setDocumentNumber] = useState(null);
  const [cardNumber, setCardNumber] = useState(null);
  const [cardNumberSecond, setCardNumberSecond] = useState(null);
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [nameFromBirth, setNameFromBirth] = useState('');
  const [status, setStatus] = useState('resubmit');
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [image, setImage] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [photoId, setphotoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [middleName, setMiddleName] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [thirdPartySign, setThirdPartySign] = useState(null);
  const [photoIdText, setPhotoIdText] = useState(null);
  const statusTextMap = {
    'to-review': 'To Review',
    'in-progress': 'In Progress',
    resubmit: 'Sent For Resubmit',
    approval: 'Approval',
  };
  const [photoIdFirstText, setphotoIdFirstText] = useState('');
  const [photoIdFirst, setphotoIdFirst] = useState(null);
  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [dob, setDob] = useState(null);
  const [formattedDOB, setFormattedDOB] = useState('');
  const [formerNames, setFormerNames] = useState(null);
  const [redAddress, setRedAddress] = useState(null);
  const [clientNo, setClientNo] = useState(null);
  const [description, setDescription] = useState(null);
  const [fileProof, setFileProof] = useState(null);
  const [documentNumberSecond, setDocumentNumberSecond] = useState(null);
  const [customerType, setCustomerType] = useState('');
  const [lastNameSignup, setLastNameSignup] = useState('');
  const [firstNameSignup, setFirstNameSignup] = useState('');
  const [email, setEmail] = useState('');
  const [statusData, setStatusData] = useState([]);
  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 4,
      multi_select: 6,
      file: 8,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  const pendingQuestions = mapQuestions(
    (eddResponse?.pending || []).flatMap((item) => item.questions || []),
  );

  const completedQuestions = mapQuestions(
    (eddResponse?.completed || []).flatMap((item) => item.questions || []),
  );
  const completedGroups = (eddResponse?.completed || []).map((item) => ({
    id: item.id,
    requestedBy: item.requested_by?.name,
    respondedAt: item.responded_at,
    questions: mapQuestions(item.questions || []),
  }));
  const updateLiveness = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agent/customers/review/${customerId}/liveness-proof/meeting-flag`;

    const bodyData = {
      has_met_customer: true,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateLivenessCheck = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateLiveness();
        if (response.status == 200) {
          toastMessage = {
            message: 'Details updated successfully',
            type: 'success',
          };
          setLivenessConfirmed(true);
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        setLivenessConfirmed(false);
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/edd-responses`
          : `/api/v1/agency/customers/review/${customerId}/edd-responses`,
      );
      if (response.status == 200) {
        setEddResponse(response.data);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };
  const latest = sanctionResults?.latest;

  const fullNameSanction = latest?.request_payload?.full_name || '-';
  const screeningDate = latest?.response_timestamp || '-';

  const uiMessage = latest?.ui?.message;
  const uiSummary = latest?.ui?.summary;
  const sourcesChecked =
    latest?.response_payload?.data?.evidence?.sources_checked || [];

  const matchedSources = latest?.matched_sources || [];
  const decision = latest?.decision || {};
  const getSourceStyle = (source, isMatched) => {
    if (isMatched) {
      return 'bg-gradient-to-r from-red-50 to-pink-50 text-red-600 border-red-200';
    }

    return 'bg-blue-50 text-blue-600 border-blue-200';
  };
  const formatSourceName = (source) => {
    return source
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };
  const getComplianceStatus = () => {
    if (!decision) return { label: '-', color: 'text-gray-500', sub: '' };

    if (!decision.pep && !decision.sanctions && !decision.adverse_media) {
      return {
        label: 'Clear',
        color: 'text-green-600',
        sub: uiMessage || 'No risk detected',
      };
    }

    if (decision.sanctions) {
      return {
        label: 'High Risk',
        color: 'text-red-600',
        sub: 'Sanctions match found',
      };
    }

    return {
      label: 'Review Required',
      color: 'text-amber-600',
      sub: 'Further checks recommended',
    };
  };
  const compliance = getComplianceStatus();
  const getStatusSanction = (val) => (val ? 'found' : 'completed');

  const sanctionsStatus = getStatusSanction(decision?.sanctions);
  const pepStatus = getStatusSanction(decision?.pep);
  const adverseStatus = getStatusSanction(decision?.adverse_media);
  const statusColorMap = {
    'to-review':
      'border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-30',
    'in-progress':
      'border-2  border-[#FFC421] text-[#FFC421] bg-[#FFC421] bg-opacity-30',
    resubmit:
      'border-2  border-[#3047EC] text-[#3047EC] bg-[#3047EC] bg-opacity-30',
    approval:
      'border-2  border-[#CC00FF] text-[#CC00FF] bg-[#CC00FF] bg-opacity-30',
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}`
          : `/api/v1/agency/customers/review/${customerId}`,
      );

      if (response.status == 200) {
        // Open account status
        setFirstNameSignup(
          response.data.open_account_information.first_name.value,
        );
        setLastNameSignup(
          response.data.open_account_information.last_name.value,
        );
        setEmail(response.data.open_account_information.email_address.value);
        setCustomerType(
          response.data.open_account_information.account_type.value,
        );

        //Personal info
        setProfilePic(response.data.personal_information.profile_picture_file);
        setFirstName(response.data.personal_information.first_name);
        setApplicantCountry(
          response.data.personal_information.applicant_country,
        );
        setSocialSecurityNumber(
          response.data.personal_information.social_security_number,
        );
        setLastName(response.data.personal_information.last_name);
        setMiddleName(response.data.personal_information.middle_name);
        setNameFromBirth(response.data.personal_information.is_birth_name);
        setFullName(response.data.personal_information.first_name);
        setFormerNames(response.data.personal_information.former_names);
        const date = new Date(response.data.personal_information.dob.value);
        const formattedDate = date.toLocaleDateString('en-GB');
        setDob(response.data.personal_information.dob);
        setFormattedDOB(formattedDate);
        setRedAddress(response.data.personal_information.address);
        setClientNo(response.data.open_account_information.client_id);
        // //Prove you
        setImage(response.data.liveness_proof.selfie);
        setLivenessConfirmed(response.data.liveness_proof.has_met_customer);

        // // Upload docs
        setThirdPartySign(
          response.data.proof_documents.has_prosecution_history,
        );
        setDescription(response.data.proof_documents.prosecution_description);
        setFileProof(response.data.proof_documents.prosecution_file);
        setExpiryDate(
          response.data.proof_documents.photographic_documents[0].expiry_date,
        );
        if (
          response.data.personal_information.applicant_country.value.id == 14
        ) {
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date,
          );
          setphotoId(
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id,
          );
          setDocumentNumber(
            response.data.proof_documents.photographic_documents[0]
              .document_number,
          );
          setCardNumber(
            response.data.proof_documents.photographic_documents[0]
              ?.card_number,
          );
          setPhotoIdText(
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.name,
          );

          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id != 2
          ) {
            setFilePhotographicId(
              response.data.proof_documents.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value.id == 2
          ) {
            setFileDriverLinsenceFront(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setFileDriverLinsenceBack(
              response.data.proof_documents.photographic_documents[0].back_file,
            );
          }
        }

        if (
          response.data.personal_information.applicant_country.value.id != 14
        ) {
          setphotoIdFirst(
            response.data.proof_documents.photographic_documents[0]
              .document_type,
          );
          setphotoIdFirstText(
            response.data.proof_documents.photographic_documents[0]
              .document_type_name,
          );
          if (response.data.proof_documents.photographic_documents[1]) {
            setphotoIdSecond(
              response.data.proof_documents.photographic_documents[1]
                .document_type,
            );
            setphotoIdSecondText(
              response.data.proof_documents.photographic_documents[1]
                .document_type_name,
            );
            setDocumentNumberSecond(
              response.data.proof_documents.photographic_documents[1]
                .document_number,
            );
            setCardNumberSecond(
              response.data.proof_documents.photographic_documents[1]
                ?.card_number,
            );
            setExpiryDateSecond(
              response.data.proof_documents.photographic_documents[1]
                .expiry_date,
            );
          }

          setDocumentNumber(
            response.data.proof_documents.photographic_documents[0]
              .document_number,
          );
          setCardNumber(
            response.data.proof_documents.photographic_documents[0]
              ?.card_number,
          );
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date,
          );

          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value != 2
          ) {
            setfilePhotographicIdFirst(
              response.data.proof_documents.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value == 2
          ) {
            setFileDriverLinsenceFrontFirst(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setFileDriverLinsenceBackFirst(
              response.data.proof_documents.photographic_documents[0].back_file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[1] &&
            response.data.proof_documents.photographic_documents[1]
              .document_type.value != 2
          ) {
            setfilePhotographicIdSecond(
              response.data.proof_documents.photographic_documents[1].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[1] &&
            response.data.proof_documents.photographic_documents[1]
              .document_type.value == 2
          ) {
            setFileDriverLinsenceFrontSecond(
              response.data.proof_documents.photographic_documents[1].file,
            );
            setFileDriverLinsenceBackSecond(
              response.data.proof_documents.photographic_documents[1].back_file,
            );
          }
        }
        setNonPhotoIdText(
          response.data.proof_documents.non_photogenic_id_type_name,
        );
        setfileNonPhotographicId(
          response.data.proof_documents.non_photogenic_file,
        );
        setVerificationStatus(
          response.data?.dvs_checks?.latest?.verification_result_code,
        );
        setDvsMeessage(
          response.data?.dvs_checks?.latest?.verification_result_message,
        );
        setDvsTime(response?.data?.dvs_checks?.latest?.created_at);
        setSanctionResults(response.data.sanctions_checks);
        if (roleName == 'agency_compliance') {
          setMeetingData(response.data.agent_meeting_flags);
        }
        setIsDataAvailable(true);
      }
    } catch (err) {
      setIsDataAvailable(false);
      showToast(err.message, 'error');
    }
  };
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/sections`
          : `/api/v1/agency/customers/review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data.sections);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const getOverallJourney = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/overall-status`
          : `/api/v1/agency/customers/review/${customerId}/overall-status`,
      );
      const stageIconMap = {
        application_submitted: 'description',
        sanction_verification: 'gavel',
        identity_verification: 'verified_user',
        manual_review: 'manage_search',
        approved: 'check_circle',
        rejected: 'cancel',
        resubmission: 'refresh',
      };
      if (response.status == 200) {
        const stages = response.data?.stages || [];

        const mappedStages = stages.map((item) => ({
          ...item,
          key: item.stage,
          icon: stageIconMap[item.stage] || 'circle',
        }));

        setSteps(mappedStages);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year}`;
    } catch (e) {
      return '-';
    }
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target),
      );
      if (isOutside) {
        setDropdownOpen(null); // Close dropdown if clicked outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (customerId) {
      getEddResponses();
    }
  }, [customerId]);
  const handleDropdownToggleStatus = () => {
    setDropdownOpen((prev) => !prev);
  };
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };

  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
      getOverallJourney();
    }
  }, [customerId, updateFieldStatus]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
              <span className="font-medium lg:text-lg text-sm">Review KYC</span>
            </div>
          </div>

          <div>
            <div className="flex flex-wrap justify-between items-center mb-4">
              <div className="flex items-center w-full md:w-auto p-4 mb-4 md:mb-0">
                <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto">
                  <h1 className="text-md font-medium mr-2">
                    {firstNameSignup} {lastNameSignup}
                  </h1>
                </div>
              </div>
              <div className="flex space-x-2 w-full md:w-auto">
                <button
                  onClick={() => {
                    setIsActivityLogOpen(true);
                  }}
                  className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
                >
                  <img
                    src="/backward-10-seconds.svg"
                    alt="Add Icon"
                    className="mr-2"
                  />
                  <span className="inline pr-2">Activity Log</span>
                </button>
              </div>
            </div>
            {isActivityLogOpen && (
              <ActivityLog
                onClose={() => setIsActivityLogOpen(false)}
                customerId={customerId}
              />
            )}
            <div className="w-full  p-4">
              <AuditStepper steps={steps} />
              <div className="w-full mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-6 md:px-7 md:py-7 shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
                <SectionStatusGrid sections={statusData} />
              </div>
            </div>
          </div>
          {isDataAvailable && (
            <>
              {/* Open Account Information */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {' '}
                        Open Account Information
                      </h1>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {/* Column 1 */}
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                      <label className="text-sm text-[#A6A6A6]">
                        First Name
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {firstNameSignup}
                      </div>

                      <label className="mt-2 text-sm text-[#A6A6A6]">
                        Last Name
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {lastNameSignup}
                      </div>
                    </div>

                    {/* Column 2 */}
                    <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <label className="text-sm text-[#A6A6A6]">Email</label>
                      <div className="text-sm break-all whitespace-normal max-w-full">
                        {email}
                      </div>
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col lg:pt-4 pt-0 px-4">
                      <label className="text-sm text-[#A6A6A6]">
                        Customer Type
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {customerType.name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showPopup && currentField && (
                <ReviewPopupKYC
                  isOpen={showPopup}
                  currentField={currentField}
                  currentFieldName={currentFieldName}
                  currentFieldValue={currentFieldValue}
                  currentFieldType={currentFieldType}
                  onClose={() => setShowPopup(false)}
                />
              )}
              {/* End  */}
              {/* Personal Information */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {' '}
                        Personal Information
                      </h1>
                    </div>
                  </div>
                  {/* Will add popup here */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4 ">
                      {profilePic.value && (
                        <>
                          {' '}
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Profile Picture
                            </label>
                            <StatusButton
                              status={profilePic.status}
                              count={profilePic.comments?.length}
                              disabled={true}
                              openSection={() =>
                                handleStatusClick(
                                  profilePic,
                                  'Profile Picture',
                                  profilePic.value?.presigned_url,
                                  '',
                                )
                              }
                            />
                          </div>
                          <img
                            src={profilePic.value?.presigned_url}
                            alt={`${firstName.value}`}
                            className="w-16 h-16 rounded-full object-cover"
                          />
                        </>
                      )}
                      {applicantCountry.value.id == 233 && (
                        <>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Social Security Number
                            </label>
                            <StatusButton
                              status={socialSecurityNumber.status}
                              count={socialSecurityNumber.comments?.length}
                              disabled={true}
                              openSection={() =>
                                handleStatusClick(
                                  socialSecurityNumber,
                                  'Social Security Number',
                                  socialSecurityNumber.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {socialSecurityNumber.value}
                          </div>
                        </>
                      )}
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Is this name from birth?
                        </label>
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="birthName"
                            value={true}
                            checked={nameFromBirth.value == true}
                            disabled={true}
                            className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="birthName"
                            value={false}
                            disabled={true}
                            checked={nameFromBirth.value == false}
                            className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          First Name
                        </label>
                        <StatusButton
                          status={fullName.status}
                          count={fullName.comments?.length}
                          disabled={true}
                          openSection={() =>
                            handleStatusClick(
                              fullName,
                              'First Name',
                              fullName.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{fullName.value}</div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Last Name
                        </label>
                        <StatusButton
                          status={lastName.status}
                          count={lastName.comments?.length}
                          disabled={true}
                          openSection={() =>
                            handleStatusClick(
                              lastName,
                              'Last Name',
                              lastName.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{lastName.value}</div>

                      {middleName && middleName.value && (
                        <>
                          {' '}
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Middle Name
                            </label>
                            <StatusButton
                              status={middleName.status}
                              count={middleName.comments?.length}
                              disabled={true}
                              openSection={() =>
                                handleStatusClick(
                                  middleName,
                                  'Middle Name',
                                  middleName.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">{middleName.value}</div>
                        </>
                      )}
                      {formerNames.value && formerNames.value.length > 0 && (
                        <>
                          <div className="flex mt-2  items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Customer's Former Name(s)
                            </label>
                            <StatusButton
                              status={formerNames.status}
                              count={formerNames.comments?.length}
                              disabled={true}
                              openSection={() =>
                                handleStatusClick(
                                  formerNames,
                                  "Customer's Former Name(s)",
                                  formerNames.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {formerNames.value}
                          </div>
                        </>
                      )}
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Date of Birth
                        </label>
                        <StatusButton
                          status={dob.status}
                          count={dob.comments?.length}
                          disabled={true}
                          openSection={() =>
                            handleStatusClick(
                              dob,
                              'Date of Birth',
                              formattedDOB,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{formattedDOB}</div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Applicant's Country
                        </label>
                        <StatusButton
                          status={applicantCountry.status}
                          count={applicantCountry.comments?.length}
                          disabled={true}
                          openSection={() =>
                            handleStatusClick(
                              applicantCountry,
                              "Applicant's Country",
                              applicantCountry.value.name,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">
                        {applicantCountry.value.name}
                      </div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Residential Address
                        </label>
                        <StatusButton
                          status={redAddress.status}
                          count={redAddress.comments?.length}
                          disabled={true}
                          openSection={() =>
                            handleStatusClick(
                              redAddress,
                              'Residential Address',
                              redAddress.value.google_address,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">
                        {redAddress.value.google_address}
                      </div>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col px-4">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Client No
                        </label>
                      </div>
                      <div className="mt-0 text-sm">{clientNo?.value}</div>
                    </div>
                  </div>
                  {/* End  */}
                </div>
              </div>
              {/* End  */}
              {/* Image section */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/camera.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {' '}
                        Prove Its You
                      </h1>
                    </div>
                  </div>
                  <div className="mt-4 px-4 flex flex-col md:flex-row gap-6 w-full">
                    {' '}
                    {/* IMAGE SECTION */}
                    <div className="w-full md:max-w-[280px]">
                      <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-500">
                          Photo Upload
                        </span>

                        <StatusButton
                          status={image.status}
                          count={image.comments?.length}
                          disabled={true}
                          openSection={() =>
                            handleStatusClick(
                              image,
                              'Photo Upload',
                              image.value.presigned_url,
                              '',
                            )
                          }
                        />
                      </div>

                      <div className="mt-2 relative w-full h-44 rounded-xl overflow-hidden border bg-gray-50">
                        <img
                          src={image.value.presigned_url}
                          alt="Uploaded"
                          className="w-full h-full object-cover"
                        />

                        <button
                          onClick={() => setFullscreen(true)}
                          className="absolute top-2 right-2 bg-white/90 hover:bg-white p-2 rounded-full shadow transition"
                        >
                          <img src="/show-full.svg" className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                    {/* RIGHT SIDE (STATUS + CONFIRMATION STACKED CLEANLY) */}
                    {roleName === 'agent' && (
                      <div className="flex-1">
                        <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 flex items-start gap-3">
                          <input
                            type="checkbox"
                            checked={livenessConfirmed}
                            onChange={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateLivenessCheck(e);
                            }}
                            disabled={livenessConfirmed}
                            className="mt-1 w-4 h-4 accent-[#375AE7]"
                          />

                          <label className="text-sm text-gray-800 leading-relaxed">
                            I confirm the person in the document matches the
                            customer I met in person.
                          </label>
                        </div>
                      </div>
                    )}
                    {roleName === 'agency_compliance' && (
                      <div className="flex-1">
                        {/* Header */}
                        <div className="flex items-center justify-between mb-3">
                          <h3 className="text-sm font-semibold text-gray-700">
                            Team Member Meeting Status
                          </h3>

                          <span className="text-xs text-gray-400">
                            {meetingData?.length} team members
                          </span>
                        </div>

                        {/* Scrollable container for large lists */}
                        <div className="max-h-[420px] overflow-y-auto pr-2 space-y-3">
                          {meetingData?.map((agent) => (
                            <div
                              key={agent.agent_user_id}
                              className="flex items-center justify-between p-3 rounded-xl border bg-white hover:bg-gray-50 transition"
                            >
                              {/* LEFT: identity */}
                              <div className="flex items-center gap-3 min-w-0">
                                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white text-sm font-semibold">
                                  {agent.agent_name?.charAt(0) || 'A'}
                                </div>

                                <div className="min-w-0">
                                  <p className="text-sm font-medium text-gray-800 truncate">
                                    {agent.agent_name}
                                  </p>
                                  <p className="text-xs text-gray-500 truncate">
                                    {agent.agent_email}
                                  </p>
                                </div>
                              </div>

                              {/* RIGHT: status */}
                              <div className="flex items-center gap-3">
                                <span
                                  className={`text-[11px] px-2 py-1 rounded-full font-medium border ${
                                    agent.has_met_customer
                                      ? 'bg-green-50 text-green-600 border-green-200'
                                      : 'bg-red-50 text-red-600 border-red-200'
                                  }`}
                                >
                                  {agent.has_met_customer ? 'Met' : 'Not Met'}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image.value.presigned_url}
                    alt="Fullscreen"
                    className="max-w-full max-h-full object-contain rounded-md shadow-lg"
                  />
                </div>
              )}
              {/* End */}
              {/* Upload Proof Documents */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex flex-wrap md:flex-nowrap items-center justify-between border-colour-custom pt-2 px-4 gap-4">
                    {/* Left Section (Title + Icon) */}
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/note-2.svg"
                        alt="User Avatar"
                        className="h-6 w-6"
                      />
                      <h1 className="text-md font-medium">
                        Upload Proof Documents
                      </h1>
                    </div>
                  </div>

                  {/* Will add popup here */}
                  <div className="grid grid-cols-1 pb-4 mx-4 border-b sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col   md:pl-4 md:pr-0 pt-4 ">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="whitespace-normal break-words text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                        >
                          Details of any current or recent prosecutions and
                          inquiries related to Money Laundering, terrorist
                          links, tax offences and corruption in respect of the
                          Individual
                        </label>
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="thirdPartySign"
                            value="yes"
                            checked={thirdPartySign.value === true}
                            className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="thirdPartySign"
                            value="no"
                            checked={thirdPartySign.value === false}
                            className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>{' '}
                      {thirdPartySign.value === true && (
                        <>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Description
                            </label>
                            <StatusButton
                              status={description.status}
                              count={description.comments?.length}
                              disabled={true}
                              openSection={() =>
                                handleStatusClick(
                                  description,
                                  'Description',
                                  description.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {description.value}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 md:pl-4 pr-2">
                      {thirdPartySign.value === true && (
                        <>
                          <FileUploadDisplay
                            label="Upload Proof"
                            disabled={true}
                            fileData={fileProof}
                            onFileClick={handleFileClick}
                          />
                        </>
                      )}
                    </div>
                    <div className="flex lg:pt-4 pt-0 md:pl-4 pr-2 flex-col"></div>
                  </div>
                  {/* Extra details */}
                  <div className="grid grid-cols-1 pb-4 pt-2 mx-4 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col tex-xs ">
                      {applicantCountry.value.id == 14 && (
                        <>
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Photographic ID
                            </label>
                            {/* {photoIdText.dvsverification_status && <DvsVerified />} */}
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdText}
                          </div>
                          {(photoId == 1 || photoId == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoId == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                disabled={true}
                                fileData={filePhotographicId}
                                onFileClick={handleFileClick}
                              />
                              {photoId == 1 && (
                                <>
                                  <div className="mt-2 flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      disabled={true}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          'Passport Number',
                                          documentNumber.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                              {photoId == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      disabled={true}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          'Document Number',
                                          documentNumber.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoId == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFront}
                                onFileClick={handleFileClick}
                                disabled={true}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBack}
                                onFileClick={handleFileClick}
                                disabled={true}
                              />
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumber.status}
                                  count={documentNumber.comments?.length}
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumber,
                                      "Driver's License Number",
                                      documentNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumber.value}</span>
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Card Number
                                </label>
                                <StatusButton
                                  status={cardNumber.status}
                                  count={cardNumber.comments?.length}
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      cardNumber,
                                      'Card Number',
                                      cardNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{cardNumber.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDate.status}
                              count={expiryDate.comments?.length}
                              disabled={true}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDate,
                                  ' Expiry Date',
                                  expiryDate
                                    ? new Date(
                                        expiryDate.value,
                                      ).toLocaleDateString('en-GB')
                                    : '',
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDate
                              ? new Date(expiryDate.value).toLocaleDateString(
                                  'en-GB',
                                )
                              : ''}
                          </div>
                        </>
                      )}
                      {applicantCountry.value.id != 14 && (
                        <>
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                            >
                              Select First Photographic ID
                            </label>
                            {/* {photoIdFirstText.dvsverification_status && <DvsVerified />} */}
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdFirstText.value}
                          </div>
                          {(photoIdFirst.value == 1 ||
                            photoIdFirst.value == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdFirst.value == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                disabled={true}
                                fileData={filePhotographicIdFirst}
                                onFileClick={handleFileClick}
                              />
                              {photoIdFirst.value == 1 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      disabled={true}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          'Passport Number',
                                          documentNumber.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                              {photoIdFirst.value == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      disabled={true}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          'Document Number',
                                          documentNumber.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoIdFirst.value == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontFirst}
                                onFileClick={handleFileClick}
                                disabled={true}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackFirst}
                                onFileClick={handleFileClick}
                                disabled={true}
                              />

                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumber.status}
                                  count={documentNumber.comments?.length}
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumber,
                                      "Driver's License Number",
                                      documentNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumber.value}</span>
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Card Number
                                </label>
                                <StatusButton
                                  status={cardNumber.status}
                                  count={cardNumber.comments?.length}
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      cardNumber,
                                      'Card Number',
                                      cardNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{cardNumber.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDate.status}
                              count={expiryDate.comments?.length}
                              disabled={true}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDate,
                                  'Expiry Date',
                                  expiryDate
                                    ? new Date(
                                        expiryDate.value,
                                      ).toLocaleDateString('en-GB')
                                    : '',
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDate
                              ? new Date(expiryDate.value).toLocaleDateString(
                                  'en-GB',
                                )
                              : ''}
                          </div>
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                            >
                              Select Second Photographic ID
                            </label>
                            {/* {photoIdSecondText.dvsverification_status && <DvsVerified />} */}
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdSecondText.value}
                          </div>
                          {(photoIdSecond.value == 1 ||
                            photoIdSecond.value == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdSecond.value == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicIdSecond}
                                disabled={true}
                                onFileClick={handleFileClick}
                              />
                              {photoIdSecond.value == 1 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number
                                    </label>
                                    <StatusButton
                                      status={documentNumberSecond.status}
                                      count={
                                        documentNumberSecond.comments?.length
                                      }
                                      disabled={true}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumberSecond,
                                          'Passport Number',
                                          documentNumberSecond.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumberSecond.value}</span>
                                </>
                              )}
                              {photoIdSecond.value == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumberSecond.status}
                                      count={
                                        documentNumberSecond.comments?.length
                                      }
                                      disabled={true}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumberSecond,
                                          'Document Number',
                                          documentNumberSecond.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumberSecond.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoIdSecond.value == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontSecond}
                                onFileClick={handleFileClick}
                                disabled={true}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackSecond}
                                onFileClick={handleFileClick}
                                disabled={true}
                              />
                              <div className="flex items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumberSecond.status}
                                  count={documentNumberSecond.comments?.length}
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumberSecond,
                                      "Driver's License Number",
                                      documentNumberSecond.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumberSecond.value}</span>
                              <div className="flex items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                >
                                  Card Number
                                </label>
                                <StatusButton
                                  status={cardNumberSecond.status}
                                  count={cardNumberSecond.comments?.length}
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      cardNumberSecond,
                                      'Card Number',
                                      cardNumberSecond.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{cardNumberSecond.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDateSecond.status}
                              count={expiryDateSecond.comments?.length}
                              disabled={true}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDateSecond,
                                  'Expiry Date',
                                  expiryDateSecond
                                    ? new Date(
                                        expiryDateSecond.value,
                                      ).toLocaleDateString('en-GB')
                                    : '',
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDateSecond
                              ? new Date(
                                  expiryDateSecond.value,
                                ).toLocaleDateString('en-GB')
                              : ''}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="flex px-2 flex-col lg:pt-2 pt-0  sm:border-l-0 sm:border-r-0 md:border-r border-gray-300 ">
                      {photoId != 2 && (
                        <>
                          <div className="flex items-center justify-between ">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                            >
                              Non Photographic ID
                            </label>
                            {/* {nonphotoIdText.dvsverification_status && <DvsVerified />} */}
                          </div>
                          <span>{nonphotoIdText.value}</span>
                          <FileUploadDisplay
                            label="Uploaded Document"
                            fileData={fileNonPhotographicId}
                            onFileClick={handleFileClick}
                            disabled={true}
                          />
                        </>
                      )}
                    </div>

                    <div className="flex lg:pt-2 pt-0 flex-col"></div>
                  </div>
                </div>
              </div>
              {/* End  */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {' '}
                        Scan Results
                      </h1>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                    {/* Column 1 */}
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                      <label className="text-sm text-[#A6A6A6]">
                        Verification Status
                      </label>
                      <div className="text-sm break-words max-w-full">
                        <button
                          className={` w-40 mt-1 text-left cursor-text font-medium  rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                            verificationStatus?.code == 'Y'
                              ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                              : ''
                          }
                                                ${
                                                  verificationStatus?.code ==
                                                  'N'
                                                    ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                                    : ''
                                                }
                
                                            `}
                        >
                          <span className="mr-6 text-left">
                            {verificationStatus?.label}
                          </span>
                        </button>
                      </div>

                      <label className="mt-2 text-sm text-[#A6A6A6]">
                        Date
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {formatDateTimeUTC(dvsTime)}
                      </div>
                    </div>

                    {/* Column 2 */}
                    <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l border-gray-300 px-4">
                      <label className="text-sm text-[#A6A6A6]">Message</label>
                      <div className="text-sm break-all whitespace-normal max-w-full">
                        {dvsMeessage}
                      </div>
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col lg:pt-4 pt-0 px-4"></div>
                  </div>
                </div>
              </div>
              <div className="w-full  p-4">
                <div className="bg-gradient-to-br from-gray-50 via-white to-gray-100 p-5 mt-4 rounded-2xl border space-y-6">
                  {/* HEADER */}
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                    <div>
                      <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                        👤{' '}
                        <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                          {fullNameSanction}
                        </span>
                      </h2>
                      <p className="text-xs text-gray-500">
                        Full Screening Overview
                      </p>
                    </div>
                  </div>

                  {/* SCORE + SUMMARY */}
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white/80 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                      <p className="text-xs text-gray-500 flex items-center gap-1">
                        📅 Last Screening
                      </p>
                      <h2 className="text-lg font-semibold text-gray-800">
                        {screeningDate}
                      </h2>
                      <p className="text-xs text-gray-400">
                        Auto-updated in real time
                      </p>
                    </div>

                    <div className="bg-white/80 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                      <p className="text-xs text-gray-500 flex items-center gap-1">
                        🛡️ Compliance Status
                      </p>
                      <h2
                        className={`text-lg font-semibold ${compliance.color}`}
                      >
                        {compliance.label}
                      </h2>
                      <p className="text-xs text-gray-400">{compliance.sub}</p>
                    </div>
                  </div>

                  {/* CHECKS GRID */}
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="hover:scale-[1.02] transition">
                      <CheckItem
                        label="Sanctions Screening"
                        status={sanctionsStatus}
                      />
                    </div>
                    <div className="hover:scale-[1.02] transition">
                      <CheckItem label="PEP Check" status={pepStatus} />
                    </div>
                    <div className="hover:scale-[1.02] transition">
                      <CheckItem label="Adverse Media" status={adverseStatus} />
                    </div>
                  </div>

                  {/* SOURCES SECTION */}
                  <div className="bg-white/90 backdrop-blur p-5 rounded-2xl border shadow-sm space-y-6">
                    {/* Checked Sources */}
                    <div>
                      <h3 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                        🔍 Sources Checked
                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 border border-blue-200">
                          {sourcesChecked.length}
                        </span>
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {sourcesChecked.length > 0 ? (
                          sourcesChecked.map((source, index) => {
                            const isMatched = matchedSources.includes(source);

                            return (
                              <span
                                key={index}
                                className={`px-3 py-1 text-xs rounded-full border flex items-center gap-1 transition-all duration-200 hover:scale-105 ${getSourceStyle(
                                  source,
                                  isMatched,
                                )}`}
                              >
                                {isMatched ? '⚠️' : '✔️'}

                                {formatSourceName(source)}

                                {isMatched && (
                                  <span className="ml-1 text-[10px] font-medium">
                                    (Match)
                                  </span>
                                )}
                              </span>
                            );
                          })
                        ) : (
                          <p className="text-xs text-gray-400">
                            No sources available
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Matched Sources */}
                    <div>
                      <h3 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                        🎯 Matched Sources
                      </h3>

                      {matchedSources.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {matchedSources.map((source, index) => (
                            <span
                              key={index}
                              className="px-3 py-1 text-xs rounded-full border flex items-center gap-1 bg-gradient-to-r from-red-50 to-pink-50 text-red-600 border-red-200 shadow-sm hover:scale-105 transition"
                            >
                              ⚠️ {source}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <div className="flex items-center gap-2 text-xs text-green-700 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 px-3 py-2 rounded-lg">
                          ✅ No matches found across all screened sources
                        </div>
                      )}
                    </div>
                  </div>

                  {/* INSIGHT PANEL */}
                  <div className="bg-white/90 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                    <h3 className="text-sm font-semibold text-gray-800 mb-2 flex items-center gap-2">
                      🧠 Compliance Insight Summary
                    </h3>

                    <p className="text-xs text-gray-600 leading-relaxed">
                      {uiSummary || 'No summary available'}
                    </p>
                  </div>
                </div>
              </div>
              {(pendingQuestions.length > 0 || completedGroups.length > 0) && (
                <div className="bg-white rounded-2xl p-4">
                  <div className="bg-white border rounded-2xl p-4 mt-4">
                    {pendingQuestions.length > 0 && (
                      <div className="w-full p-4">
                        <UserQuestionnaire
                          apidata={pendingQuestions}
                          customerName={firstNameSignup + ' ' + lastNameSignup}
                          isPending={true}
                          heading={'Customer Submitted ECDD Responses'}
                        />
                      </div>
                    )}
                    {completedGroups.length > 0 && (
                      <div className="w-full p-4">
                        <UserQuestionnaire
                          apidata={completedGroups}
                          customerName={firstNameSignup + ' ' + lastNameSignup}
                          isPending={false}
                          heading={'Customer Submitted ECDD Responses'}
                        />
                      </div>
                    )}{' '}
                  </div>
                </div>
              )}
              <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
                {/* Right Section: Download Button */}
                <div className="flex items-center justify-end w-full">
                  <div className="relative inline-block mr-4">
                    {/* Button */}
                    <div
                      className="flex text-sm justify-between items-center py-2 px-2 border border-white  w-40 rounded-full cursor-pointer"
                      onClick={() => {
                        const historyStack = location.state?.historyStack || [];
                        const lastRoute =
                          historyStack.length > 0
                            ? historyStack[historyStack.length - 1]
                            : '/';

                        navigate(lastRoute, {
                          state: {
                            fromViewHistory: true,
                            historyStack: historyStack.slice(
                              0,
                              historyStack.length - 1,
                            ),
                          },
                        });
                      }}
                    >
                      <span className="text-right pl-4 text-white">Back</span>
                    </div>
                  </div>
                </div>
                {showModal && (
                  <EDDModal
                    pendingQuestions={pendingQuestions}
                    completedQuestions={completedQuestions}
                    closeModal={() => {
                      setShowModal(false);
                      getEddResponses();
                    }}
                  />
                )}
              </div>
            </>
          )}
        </>
      )}

      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};
const CheckItem = ({ label, status }) => {
  const styles = {
    completed: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    found: 'bg-red-50 text-red-700 border-red-100',
    warn: 'bg-amber-50 text-amber-700 border-amber-100',
  };

  const icons = {
    completed: '✔',
    found: '✖',
    warn: '⚠',
  };

  return (
    <div
      className={`flex justify-between items-center p-3 rounded-xl border shadow-sm ${styles[status]} transition hover:shadow-md`}
    >
      <span className="text-xs font-medium text-gray-800">{label}</span>

      <span className="text-xs font-semibold flex items-center gap-1">
        {icons[status]} {status.toUpperCase()}
      </span>
    </div>
  );
};
export default ReviewKycJointAccountReadOnly;
